import { ContentfulClientApi, Entry, createClient, Space } from 'contentful';
import { RootModel, PageModel } from '../types/content-models';
import { ContentType } from '../types/enums/content-type';

export default class ContentService {

    private client: ContentfulClientApi;
    constructor() {
        this.client = createClient({
            space: 'jisoou4ycx5a',
            accessToken: 'MlqnvdrbbZwjnUVBt7nkJeggbq4ojoJb89NypJZ1118'
        });
    }

    async getSpace(): Promise<Space> {
        return await this.client.getSpace();
    }

    async getRoot(): Promise<Entry<RootModel>> {
        return (await this.client.getEntries<RootModel>({
            'content_type': ContentType.Root, 
            limit: 1,
            include: 1 
        })).items[0];
    }

    private defaultEntryValues = {
        limit: 1, 
        include: 3 // Content ref depth that should be included in the response
    }

    async getEntry<T>(contentId: string, include: number = 3): Promise<Entry<T>> {
        return await this.client.getEntry<T>(contentId, { 
            limit: 1,
            include
        });
    }

    async getPageByUrl(url: string, include: number = 3): Promise<Entry<PageModel>> {
        const result = await this.client.getEntries<PageModel>({
            'content_type': ContentType.Page,
            'fields.url': url,
            limit: 1,
            include
        });
        return result.items[0];
    }
}